module.exports = __webpack_public_path__ + "static/media/blackOpacityMarker.6349ec33.svg";